import { Service } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { RegisteredDataProviders } from '@lib.core/data-provider/registered-data-providers';

@Service()
export class DataProviderRegistry<T> {
  private readonly storage = new Map<RegisteredDataProviders, BehaviorSubject<T | null>>();

  private registerKey(key: RegisteredDataProviders): BehaviorSubject<T | null> {
    let dataProvider$$: BehaviorSubject<T | null> | undefined = this.storage.get(key);
    if (dataProvider$$ === undefined) {
      dataProvider$$ = new BehaviorSubject<T | null>(null);
      this.storage.set(key, dataProvider$$);
    }
    return dataProvider$$;
  }

  getDataProvider(key: RegisteredDataProviders): Observable<T> {
    return this.registerKey(key).asObservable().pipe(filter((dataProvider: T | null) => dataProvider !== null));
  }

  setDataProvider(key: RegisteredDataProviders, provider: T): this {
    const dataProvider$$: BehaviorSubject<T | null> = this.registerKey(key);
    if (dataProvider$$.getValue() === null) {
      dataProvider$$.next(provider);
    }
    return this;
  }

  destroy(key: RegisteredDataProviders): void {
    const dataProvider$$: BehaviorSubject<T | null> | undefined = this.storage.get(key);
    if (dataProvider$$ !== undefined) {
      dataProvider$$.complete();
    }
    this.storage.delete(key);
  }

  destroyAll(): void {
    this.storage.forEach((dataProvider$$: BehaviorSubject<T | null>) => dataProvider$$.complete());
    this.storage.clear();
  }
}
